import React from 'react';

import {PredictionPlaceholder} from "../../../../core/components/prediction/components/placeholder/prediction.placeholder";
import {GamesPredictionsWidgetHeaderPlaceholder} from "./games-predictions-widget.header.placeholder";
import {GamesPredictionsWidgetGamePlaceholder} from "./games-predictions-widget.game.placeholder";

export const GamesPredictionsWidgetPlaceholder = (props) => {
  return (
    <div className={['games-predictions-widget-placeholder', props.className].join(' ')}>
      <GamesPredictionsWidgetHeaderPlaceholder/>
      <GamesPredictionsWidgetGamePlaceholder/>
      <PredictionPlaceholder/>
    </div>
  )
}
